<template>
  <div class="email-timeline" data-testId="message-events">
    <p v-if="loading" class="email-timeline__message">Carregando rastreio...</p>

    <div v-else-if="error">
      <p class="email-timeline__message">{{ error }}</p>
      <vs-button size="small" type="border" @click="$emit('retry')">
        Tentar novamente
      </vs-button>
    </div>

    <p v-else-if="!events.length" class="email-timeline__message">
      Sem eventos de rastreio para esta mensagem.
    </p>

    <template v-else>
      <p class="email-timeline__title">
        Linha do tempo de interação com o e-mail (AWS SES)
      </p>

      <ul class="email-timeline__list">
        <li
          v-for="(event, index) in events"
          :key="index"
          class="email-timeline__item"
        >
          <span
            class="email-timeline__marker"
            :class="`email-timeline__marker--${eventStyle(event).color}`"
          >
            <vs-icon :icon="eventStyle(event).icon" size="15px" color="#fff" />
          </span>

          <div class="email-timeline__content">
            <strong class="email-timeline__label">
              <a
                v-if="event.link"
                class="email-timeline__link"
                :href="event.link"
                target="_blank"
                rel="noopener noreferrer"
                v-tooltip="eventTooltip(event)"
                >{{ eventLabel(event) }}</a
              >
              <span v-else v-tooltip="eventTooltip(event)">{{
                eventLabel(event)
              }}</span>
            </strong>
            <span class="email-timeline__time">
              {{ formatDate(event.occurredAt) }}
            </span>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>
<script>
import functions from '../../../utils/functions';
import {
  MESSAGING_EMAIL_EVENT_LABELS,
  MESSAGING_EMAIL_EVENT_STYLES,
  MESSAGING_EMAIL_EVENT_STYLE_DEFAULT,
} from '../../../utils/constants';


export default {
  name: 'EmailTrackingTimeline',
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
  },
  methods: {
    formatDate(data) {
      return functions.formatDatetimeWithMoment(data);
    },
    eventLabel(event) {
      return MESSAGING_EMAIL_EVENT_LABELS[event.eventType] || event.eventType;
    },
    eventStyle(event) {
      return (
        MESSAGING_EMAIL_EVENT_STYLES[event.eventType] ||
        MESSAGING_EMAIL_EVENT_STYLE_DEFAULT
      );
    },
    eventTooltip(event) {
      const details = [];

      if (event.recipient) {
        details.push(event.recipient);
      }
      if (event.link) {
        details.push(event.link);
      }
      if (event.bounceType) {
        details.push(`${event.bounceType} / ${event.bounceSubType}`);
      }
      if (event.complaintFeedbackType) {
        details.push(event.complaintFeedbackType);
      }
      if (event.delayType) {
        details.push(event.delayType);
      }
      if (event.reason) {
        details.push(event.reason);
      }
      if (event.templateName) {
        details.push(event.templateName);
      }
      if (event.errorMessage) {
        details.push(event.errorMessage);
      }
      if (event.diagnosticCode) {
        details.push(event.diagnosticCode);
      }
      if (event.smtpResponse) {
        details.push(event.smtpResponse);
      }
      if (event.ipAddress) {
        details.push(`IP: ${event.ipAddress}`);
      }
      if (event.isBotEvent === 'Likely') {
        details.push('possível pré-carregamento automático');
      }

      return details.join(' — ');
    },
  },
};
</script>
<style scoped>
.email-timeline {
  padding: 1rem 1.25rem;
  background-color: #f7f7f9;
  border-radius: 6px;
}

.email-timeline__message {
  margin-bottom: 0.5rem;
  font-style: italic;
}

.email-timeline__title {
  margin-bottom: 1rem;
  font-size: 0.9rem;
  color: #626262;
}

.email-timeline__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.email-timeline__item {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-bottom: 1.1rem;
}

.email-timeline__item:last-child {
  padding-bottom: 0;
}

.email-timeline__item::before {
  content: '';
  position: absolute;
  top: 22px;
  left: 10px;
  width: 2px;
  height: calc(100% - 22px);
  background-color: #28c76f;
}

.email-timeline__item:last-child::before {
  display: none;
}

.email-timeline__marker {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
}

.email-timeline__marker--success {
  background-color: #28c76f;
}

.email-timeline__marker--warning {
  background-color: #ff9f43;
}

.email-timeline__marker--danger {
  background-color: #ea5455;
}

.email-timeline__marker--primary {
  background-color: #7367f0;
}

.email-timeline__content {
  display: flex;
  flex-direction: column;
  margin-left: 0.85rem;
  line-height: 1.35;
}

.email-timeline__label {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  color: #2c2c2c;
}


.email-timeline__link {
  color: inherit;
}

.email-timeline__link:hover {
  text-decoration: underline;
}

.email-timeline__time {
  font-size: 0.85rem;
  color: #8f8f8f;
}
</style>
